//@ts-nocheck

(window as any).global = window;
